import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'

// export const baseURL = '/dev-api';
// export const baseURL = 'http://zhudun.test';
// export const baseURL = 'https://zhudunapi.test03.qcw800.com'
export const baseURL = 'https://api.zhudunm.com'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://zhudun.test',
  // baseURL: 'https://zhudun.test03.qcw800.com'
  baseURL
  // 超时
  // timeout: 10000
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken('token')) {
      config.headers['Authorization'] = 'Bearer ' + getToken('token') // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    return config
  },
  error => {
    console.log("errr333",error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  res => {
    const code = res.data.code
    
    if (!code) return res.data
    
    if ([200, 201, 9].includes(code)) {
      return res.data
    }

    return Promise.reject(res.data)
  },
  error => {
    if(error.response.status == 401){
      removeToken('token')
      // this.$router.push({
      //   path: "/pwdLogin"
      // });
      Message({
        message: "未登录,或者您的账号在别处登录",
        type: 'error',
        duration: 5 * 1000
      })
      return
    }
    console.log("error.message", error.message)
    Message({
      message: error.response ? error.response.data.message : error,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
